import styled from 'styled-components';
import { gridSizes } from 'utils/style';
import EditStopBtn from 'components/orders/OrderSummary/components/OrderStop/components/EditStopBtn/EditStopBtn';

export default styled(EditStopBtn)`
  position: absolute;
  right: 0;
  top: ${gridSizes('M')};
  color: var(--primary500);
  display: none;
  padding: 0;
  appearance: none;
  border: none;
  cursor: pointer;
`;
